<template>
  <div class="whole" flexContainer>
    <div class="logo" aspectratio @click="go_first">
      <img src="@/assets/logo.png" />
      <span>担当运营管理系统</span>
    </div>
    <div flex-1 class="tab">
      <div class="tab-area" flexContainer>
        <div
          :class="{ tab_color: item.menuId == isTab }"
          v-for="item in topList"
          :key="item.id"
          @click="change_tab(item.name, item.menuId)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="user" flexContainer>
      <div class="one">
        <span>{{ namePic }}</span>
      </div>
      <div class="two">
        <p>{{ loginData.name }}</p>
        <span>{{ loginData.roleName }}</span>
      </div>
      <div class="guan">|</div>
      <div class="three" @click="exitFun">
        <div class="exitIcon">
          <img src="../assets/exits.png" />
        </div>
      </div>
      <!-- <div style="clear:both"></div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { clearG, setGstore, getGstore, rmGstore } from "../utils/storage";
import { getList } from "@/api/index";
export default {
  data() {
    return {
      isTab: 2,
      namePic: "",
      loginData: {},
      topList: JSON.parse(localStorage.loginData).menuList || [],
    };
  },
  computed: mapState(["isTabShow", "texts_status"]),
  mounted() {
    this.fun();
  },
  methods: {
    fun() {
      this.loginData = JSON.parse(localStorage.getItem("loginData"));
      this.namePic = this.loginData.name.substr(0, 1);
      this.new_fun();
    },
    //退出登录的方法
    exitFun() {
      clearG();
      this.$router.push({
        path: `/`,
      });
    },
    //回到首页
    go_first() {
      this.$router.push({
        path: "/first",
      });
      if (localStorage.list) {
        rmGstore("list");
      }
    },
    new_fun() {
      if (localStorage.list) {
        this.change_tab(localStorage.tab_name, localStorage.tab_id);
      } else if (this.$store.state.menuList) {
        this.change_tab(
          this.$store.state.menuList[0].name,
          this.$store.state.menuList[0].menuId
        );
      } else {
        console.log("3");
      }
    },
    //切换顶部tab方法
    change_tab(name, id) {
      console.log(name, id);
      if (id != 4) {
        this.isTab = id;
        setGstore("tab_id", id);
        setGstore("tab_name", name);
        let roleId = JSON.parse(localStorage.loginData).roleId;
        let data = {
          parentId: id,
          roleId: roleId,
        };
        getList(data)
          .then((res) => {
            this.$store.state.menuList = res.data;
            if (localStorage.title) {
              this.$store.state.pageTitle = localStorage.title;
            } else {
              this.$store.state.pageTitle = this.$store.state.menuList[0].name;
            }
            console.log(res.data);
            if (res.data.length != 0) {
              setGstore("list", res.data);
              setGstore("menu_id", res.data[0].menuId);
              setGstore("menu_name", res.data[0].name);
            }

            this.$store.state.texts_status = -1;
            switch (id) {
              case 2:
                this.$store.state.isTabShow = true;
                this.$router.push({
                  path: "/org",
                });
                break;
              case 3:
                this.$store.state.isTabShow = true
                this.$router.push({
                  path: "/org_table",
                });
                break;
              // case 4:
              //   this.$router.push({
              //     path: "/publish"
              //   });
              //   break;
              case 5:
                this.$store.state.isTabShow = true
                this.$router.push({
                  path: "/admin",
                });
                break;
              case 27:
                this.$store.state.isTabShow = false;
                this.$router.push({
                  path: "/tools",
                });
                break;
              case 30:
                this.$store.state.isTabShow = true;
                this.$router.push({
                  path: "/shopHome",
                });

            }
          })
          .catch((error) => {});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.whole {
  background-color: $tab-color;
  color: $menu-color;
  height: 60px;
  .logo {
    width: 220px;
    line-height: 60px;
    margin: 0 auto;
    display: table;
    cursor: pointer;
    img {
      width: 26px;
      height: 20px;
      margin-left: 30px;
      vertical-align: sub;
    }
    span {
      @include s-c-w(16, $menu-color, 500);
      display: table-cell;
      vertical-align: middle;
    }
  }
  .tab {
    .tab-area {
      margin: 0 auto;
      line-height: 60px;
      text-align: center;
      width: 400px;
      justify-content: space-between;
      cursor: pointer;
      @include s-c-w(14, $menu-color, 500);
      .tab_color {
        @include s-c-w(14, $tab, 500);
      }
    }
  }
  .user {
    width: auto;
    color: $menu-color;
    text-align: center;
    align-items: center;
    .one {
      width: 32px;
      height: 32px;
      background-color: $back;
      border-radius: 50%;
      span {
        line-height: 32px;
        @include s-c-w(16, $menu-color, 500);
      }
    }
    .two {
      margin-left: 10px;
      margin-right: 10px;
      p {
        margin: 0;
        text-align: left;
        @include s-c-w(14, $menu-color, 500);
      }
      span {
        @include s-c-w(12, $a, 500);
        display: block;
        text-align: left;
        margin-top: 2px;
      }
    }
    .guan {
      color: $border;
      line-height: 60px;
    }
    .three {
      margin-right: 25px;
      height: 20px;
      .exitIcon {
        img {
          width: 20px;
          height: 20px;
        }
        margin-left: 19px;
      }
    }
  }
}
</style>
